<template>
    <div class="msg">
        <v-select id="hotel" v-model="hotel_id" :items="hotels" :label="getI18n('hotels.label')" :disabled="params.hotel.disabled"></v-select>
        <v-select id="event" v-model="event_id" :items="events" :label="getI18n('event')" :disabled="params.event.disabled"></v-select>
    </div>
</template>

<script>
    import store from '@/store'
    import i18n from '@/i18n'
    import {Api} from '@/core/api.js';
    const api = new Api();

    export default {
        props: { params: Object },
        components: { },
        data() {
            return {
                hotel_id: this.params.hotel.value,
                event_id: this.params.event.value,
                hotels: []
            }
        },
        computed: {
            events: function(){
                var events = store.getters[ 'events/getActives' ]();
                var aEvents = [];
                for( var i in events ){
                    var e = events[ i ];
                    aEvents.push( { text: this.formatEventName( e.name, e.edition ), value: e.id } );
                }

                return aEvents;
            }
        },
        methods: {
            getI18n( label ){
                return i18n.t( label );
            },

            formatEventName( name, edition ){
                return name + "'" + edition.substring(2);
            },

            formatParam( param ){
                switch( param.type ){
                    case 'string': return param.value;
                    case 'role': return param.value.name;
                    case 'email': return param.value;
                    case 'phone': return "<v-icon size='18px'>phone</v-icon>" + param.value;
                }
            }
        },
        created() {
            var self = this;
            api.get( 'hotel' ).then( function( response ){
                if( response.status ){
                    var data = response.data;
                    var aHotels = [];
                    for( var i in data ){
                        aHotels.push( { text: data[i].name, value: data[i].id } )
                    }
                    
                    self.hotels = aHotels
                }
            });
        },
        watch: {
            hotel_id: {
                handler( v ){
                    this.params.hotel.value = v
                },
                deep: true
            },
            event_id: {
                handler( v ){
                    this.params.event.value = v
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .avatar {
        width: 100%;
        height: 150px;
        text-align: center;

        img {
            height: 100%;
            width: auto;
        }
    }

    .item {
        text-align: center;
        margin: 10px auto;
        width: fit-content;

        &.strong .value {
            font-weight: bold;
            font-size: 22px;
        }

        &.role {
            border-radius: 15px;
            padding: 5px 15px;
            font-weight: lighter;
            margin: 0 auto;
            
            &.r5 {
                background-color: $bg-role-5;
                color: $co-role-5;
            }

            & .value {
                font-size: 18px;
                text-transform: uppercase;
            }
        }
        
        &.club {
            position: relative;
        }
    }
</style>